import { useParams } from 'react-router-dom'

import PageHeader from '../../components/PageHeader'
import { getTranslate } from '../../localization'
import { RateplanAddHeader } from './RateplanAddHeader'
import RateplanMainFormForGenerate from './RateplanMainFormForGenerate'
import RateplanMainFormForModify from './RateplanMainFormForModify'

const RateplanForm = () => {
  const params = useParams<{
    id: string
  }>()

  return (
    <div>
      <PageHeader title={getTranslate('RatePlan')} />
      <RateplanAddHeader />
      {params.id ? (
        <RateplanMainFormForModify /> //because code in generate is array of string and in modify is string, there is two seperate screen for generate and modify
      ) : (
        <RateplanMainFormForGenerate />
      )}
    </div>
  )
}

export default RateplanForm
